import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Helpers from '../../../../common/helpers';
import constants from '../../../../common/constants';
import bannersConstants from '../../banners/constants/banners-constants';
import { toggleInfoModal } from '../../../shared/info-modal/actions/info-modal-actions';
import { toggleBannerPreviewModal } from '../actions/dashboard-actions';

class LatestBanner extends Component {
  openBannerPreviewModal(bannerHtml) {
    const { toggleBannerPreviewModal } = this.props;

    toggleBannerPreviewModal(true, bannerHtml);
  }

  copyToClipboard(bannerHtml) {
    const { toggleInfoModal } = this.props;

    Helpers.copyToClipboard(bannerHtml);
    toggleInfoModal(true, constants.info_modal_types.success.value, 'DASHBOARD.COPY_BANNER_CODE_MESSAGE');
  }

  render() {
    const { t } = this.context;
    const { selectedQuickLink } = this.props;
    const banners = Helpers.getBanners(bannersConstants.banner_types.passion.value, 'EN', bannersConstants.banner_types.passion);
    const lastBanner = banners && banners.length > 0 ? banners[banners.length - 1] : {};
    const bannerHtml = Helpers.getBannerHtml(selectedQuickLink, lastBanner);

    return (
      <div className="activity-summary-container__latest-banner">
        <div className="display-flex-horizontal m-b-10">
          <p className="activity-summary-container__latest-banner__title">{t('DASHBOARD.LATEST_BANNER')}</p>
          <p className="activity-summary-container__latest-banner__action" onClick={() => this.openBannerPreviewModal(bannerHtml)}>
            {t('DASHBOARD.VIEW_BANNER')}
          </p>
        </div>
        <div className="activity-summary-container__latest-banner__body">
          <code>{bannerHtml}</code>
        </div>
        <p className="activity-summary-container__latest-banner__action text-right" onClick={() => this.copyToClipboard(bannerHtml)}>
          {t('DASHBOARD.GRAB_BANNER_CODE')}
        </p>
      </div>
    );
  }
}

LatestBanner.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  selectedQuickLink: state.dashboardReducer.selectedQuickLink,
});

const mapDispatchToProps = dispatch => ({
  toggleBannerPreviewModal: (show, bannerHtml) => {
    dispatch(toggleBannerPreviewModal(show, bannerHtml));
  },
  toggleInfoModal: (show, type, message, translations, callback, path, btnText) => {
    dispatch(toggleInfoModal(show, type, message, translations, callback, path, btnText));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LatestBanner);



// WEBPACK FOOTER //
// ./src/app/main/dashboard/components/latest-banner.js